import React from "react";
import { Button, Menu, MenuItem, Theme, createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

interface IProps {
  clickHandler?: (value: string) => void;
  options: string[];
  disabled?: boolean;
}
export default function BulkActionsButton(props: IProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStyles();
  const options: string[] = props.options;

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSelection(value: string) {
    setAnchorEl(null);
    if (props.clickHandler && value) props.clickHandler(value);
  }

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={props.disabled ? props.disabled : false}
      >
        Bulk Actions
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((value, index) => (
          <MenuItem
            onClick={() => handleSelection(value)}
            className={classes.menu}
            key={index}
          >
            {value}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menu: {
      fontSize: 14,
      minWidth: 175
    }
  })
);
